import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { ED_REDESIGN_ENABLED } from 'features/ed-redesign/config';
import { warmEdJourney } from 'features/ed-redesign/journeyData';
import Header from './header';
import Footer from './footer';
import FooterContactUs from './footer-contact-us';

type BaseAppLayoutProps = {
  footerVariant?: 'default' | 'contact';
};

export default function BaseAppLayout({ footerVariant = 'default' }: BaseAppLayoutProps) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (ED_REDESIGN_ENABLED && (pathname === '/' || pathname === '/ed-treatment')) {
      void warmEdJourney();
    }
  }, [pathname]);
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow px-4">
        <Outlet />
      </main>
      {footerVariant === 'contact' ? <FooterContactUs /> : <Footer />}
    </div>
  );
}
